import * as React from 'react';
import type { OmitStylesComponentProps } from '../../types';

export const Breadcrumb = React.forwardRef<
    HTMLElement,
    OmitStylesComponentProps<'nav'> & {
        separator?: React.ReactNode;
    }
>((props, ref) => <nav ref={ref} aria-label="breadcrumb" {...props} />);

Breadcrumb.displayName = 'Breadcrumb';
